import { MergedBase } from "../mfrm-choose-your-foundation";

export const getTabs = (bases: MergedBase[]) => {
    const springs = bases.filter(base => base.productType === 'Box Springs');
    const canFilterByBoxSpring = springs.length > 0 && springs.length < bases.length;

    const adjustableBases = bases.filter(base =>base.productType === 'Adjustable Bases');
    const canFilterByAdjustableBases = adjustableBases.length > 0 && adjustableBases.length < bases.length;

    const tabs = [];

    if ((canFilterByBoxSpring || canFilterByAdjustableBases)) {
        tabs.push('All');
    }
    if (canFilterByAdjustableBases) {
        tabs.push('Adjustable Bases');
    }
    if (canFilterByBoxSpring) {
        tabs.push('Box Springs');
    }

    return tabs;
};